import React from 'react';
import { Home, PieChart, Plus, Wrench, BarChart2 } from 'lucide-react';
import '../styles/BottomNav.css';

const BottomNav = ({ activeTab, setActiveTab, onAddClick, t, isPro, isServiceAccount }) => {
  return (
    <div className="bottom-nav" style={{ 
      bottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
      justifyContent: isServiceAccount ? 'center' : 'space-between',
      gap: isServiceAccount ? '1.5rem' : undefined,
      minWidth: isServiceAccount ? 'auto' : undefined,
      padding: isServiceAccount ? '0 24px' : undefined
    }}>
      {!isServiceAccount && (
        <>
          <button 
            className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            <Home size={24} />
          </button>
          
          <div className="nav-item-center">
            <button className="add-btn-main" onClick={onAddClick}>
              <Plus size={28} />
            </button>
          </div>

          <button 
            className={`nav-item ${activeTab === 'expenses' ? 'active' : ''}`}
            onClick={() => setActiveTab('expenses')}
          >
            <PieChart size={24} />
          </button>
        </>
      )}

      {isServiceAccount && (
        <>
          <button 
            className={`nav-item ${activeTab === 'service' ? 'active' : ''}`}
            onClick={() => setActiveTab('service')}
          >
            <Wrench size={24} />
          </button>
          <button 
            className={`nav-item ${activeTab === 'service-stats' ? 'active' : ''}`}
            onClick={() => setActiveTab('service-stats')}
          >
            <BarChart2 size={24} />
          </button>
        </>
      )}
    </div>
  );
};

export default BottomNav;
